import { jsx as s } from "react/jsx-runtime";
import c from "react";
import { useProviderContext as $ } from "@rmwc/provider";
import { Tag as S, createComponent as w, classNames as N, getDisplayName as E } from "@rmwc/base";
const M = (e) => typeof e == "string" && e.includes("/") ? "url" : c.isValidElement(e) ? "component" : "ligature", V = (e, r, o) => (r = r || o || "auto", r === "auto" ? M(e) : r), j = ({ content: e, ...r }) => /* @__PURE__ */ s(i, { ...r, children: e }), z = ({
  content: e,
  ...r
}) => /* @__PURE__ */ s(i, { ...r }), A = ({ content: e, ...r }) => /* @__PURE__ */ s(
  i,
  {
    ...r,
    style: {
      ...r.style,
      backgroundImage: `url(${e})`
    }
  }
), D = ({
  content: e,
  ...r
}) => {
  if (e.type === "svg") {
    const { children: o, ...l } = e.props;
    return /* @__PURE__ */ s(i, { ...l, ...r, tag: "svg", children: o });
  }
  return /* @__PURE__ */ s(i, { ...r, children: e });
}, F = {
  ligature: j,
  className: z,
  url: A,
  component: D,
  auto: void 0
}, P = (e) => c.isValidElement(e) || e && typeof e != "object" ? {
  icon: e
} : e, i = c.forwardRef(function(r, o) {
  return /* @__PURE__ */ s(S, { tag: "i", ...r, ref: o });
}), k = w(function({ icon: e, ...r }, o) {
  const l = $(), {
    icon: a,
    strategy: v,
    prefix: y,
    basename: d,
    render: h,
    size: m,
    ...u
  } = {
    ...P(e)
  }, {
    basename: I = null,
    prefix: x = null,
    strategy: R = null,
    render: b = null
  } = l.icon || {}, f = a, t = V(
    f,
    v || null,
    R || null
  ), C = y || x, T = d === void 0 ? I : d, U = t === "className" && typeof a == "string" ? `${String(C)}${a}` : null;
  let p = !!t && F[t] || null;
  if (t === "custom" && (p = h || b), !p)
    return console.error(
      `Icon: rendering not implemented for ${String(t)}.`
    ), null;
  const n = p({
    ...r,
    ...u,
    ref: o,
    content: f,
    className: N(
      "rmwc-icon",
      `rmwc-icon--${t}`,
      T,
      r.className,
      u.className,
      U,
      {
        [`rmwc-icon--size-${m || ""}`]: !!m
      }
    )
  });
  if (!c.isValidElement(n))
    return null;
  const g = E(n.props.children);
  return g.includes("Avatar") || g.includes("Icon") ? c.cloneElement(n.props.children, {
    ...n.props.children.props,
    ...n.props,
    ref: o,
    // prevents an infinite loop
    children: n.props.children.props.children,
    className: N(
      n.props.className,
      n.props.children.props.className
    )
  }) : n;
});
k.displayName = "Icon";
export {
  k as Icon,
  V as getIconStrategy
};
